import {useConfigContext} from "../ConfigProvider.tsx";

export const useTranslations = () => {
    const { tc } = useConfigContext();
    return tc;
};